<template>
  <div
    class="formRadio"
    :class="{
      'formRadio--collapseActive': collapse,
      'formRadio--mobileCollapse': mobileCollapse,
    }"
  >
    <div
      v-if="label"
      class="formRadio__title"
      :class="{ 'formRadio__title--mobileCollapse': mobileCollapse }"
      @click="toggleCollapse"
    >
      {{ label }}
    </div>
    <div
      ref="formRadioGroup"
      class="formRadio__group"
      :class="{
        'formRadio__group--mobileCollapse': mobileCollapse,
        'formRadio__group--newLine': newLine,
      }"
    >
      <div v-for="(option, index) in options" :key="index" class="formRadio__groupItem">
        <input
          :id="`${id}_${index}`"
          v-model="checkedValue"
          type="radio"
          :value="option.value"
          class="formRadio__input"
          @change="onInput"
        />
        <label
          :for="`${id}_${index}`"
          class="formRadio__label"
          :class="{
            'formRadio__label--noWrap': noWrap,
            'formRadio__label--hideCircle': hideCircle,
          }"
        >
          {{ option.label }}
          <span v-if="option.available" class="formRadio__labelNumber">
            ({{ option.available }})
          </span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormRadio',
  props: {
    id: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: undefined,
    },
    options: {
      type: [Array, Object],
      default: () => {},
    },
    mobileCollapse: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    newLine: {
      type: Boolean,
      default: false,
    },
    noWrap: {
      type: Boolean,
      default: false,
    },
    hideCircle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checkedValue: this.value,
      collapse: false,
    };
  },
  watch: {
    value(val) {
      this.checkedValue = this.value;
    },
  },
  methods: {
    onInput(e) {
      this.$emit('input', e.target.value);
      this.$emit('emitObject', { name: this.name, value: e.target.value });
    },
    toggleCollapse() {
      if (this.collapse) {
        this.collapse = false;
        this.$refs.formRadioGroup.style.maxHeight = '';
      } else {
        this.collapse = true;
        this.$refs.formRadioGroup.style.maxHeight = `${this.$refs.formRadioGroup.scrollHeight}px`;
      }
    },
  },
};
</script>

<style lang="scss">
.formRadio {
  $root: &;
  transition: padding $tr;

  &--mobileCollapse {
    @include rwd('large-tablet') {
      border-bottom: 1px solid $cAddLight;
    }
  }

  &--collapseActive {
    padding-bottom: 2rem;

    #{$root}__title {
      &:after {
        transform: rotate(180deg);
      }
    }
  }

  &__title {
    margin-bottom: 1.3rem;
    font-size: 1.6rem;
    line-height: 2rem;
    font-weight: 600;
    color: $cMainDark;

    &--mobileCollapse {
      @include rwd('large-tablet') {
        display: flex;
        justify-content: space-between;
        padding: 1.8rem 0 1rem;

        &:after {
          @include icomoon('chevron-down');
          color: $cMainLight;
          font-size: 0.8rem;
          transition: transform $tr;
        }
      }
    }
  }

  &__label {
    position: relative;
    display: flex;
    font-size: 1.4rem;
    line-height: 2rem;
    color: $cMainLight;
    padding-left: 2.6rem;
    padding-top: 2px;
    padding-bottom: 2px;
    cursor: pointer;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 4px;
      width: 16px;
      height: 16px;
      border: 1px solid $cCheckbox;
      border-radius: 50%;
    }

    &:after {
      content: '';
      position: absolute;
      left: 8px;
      top: 8px;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      background-color: $cSec;
      border-radius: 50%;
      opacity: 0;
      transition: width $tr, height $tr, opacity $tr;
    }
  }

  &__input {
    display: none;

    &:checked {
      ~ #{$root}__label {
        &:after {
          width: 8px;
          height: 8px;
          opacity: 1;
        }

        &--hideCircle {
          color: $cMainDark;
          font-weight: 600;
        }
      }
    }
  }

  &__group {
    display: flex;
    margin-left: -1rem;
    margin-right: -1rem;

    &--newLine {
      flex-wrap: wrap;

      #{$root}__groupItem {
        flex: 0 0 100%;
        max-width: 100%;
      }
    }

    &--mobileCollapse {
      @include rwd('large-tablet') {
        max-height: 0;
        overflow: hidden;
        transition: max-height $tr;
      }
    }
  }

  &__groupItem {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  &__label {
    &--noWrap {
      white-space: nowrap;
      width: 100%;
    }

    &--hideCircle {
      color: $cAddDark02;
      padding-left: 0;
      transition: color $tr;

      &:hover {
        color: $cMainDark;
      }

      &:before,
      &:after {
        display: none;
      }
    }
  }

  &__labelNumber {
    color: $cAddDark02;
  }

  &.is-invalid {
    #{$root}__label {
      &:before {
        border: 2px solid $cBadgeProm;
      }
    }
  }
}
</style>
